// extracted by mini-css-extract-plugin
module.exports = {"docSummaryList":"styles_docSummaryList__HjF7F","listItem":"styles_listItem__10P_J","listItemTitle":"styles_listItemTitle__2kX4g"};